import React, { Component } from 'react';

import ProfileNextToName from 'resources/assets/react-app/uiHooks/react-social/profileNextToName';

import ProfileUnderProfileImage from 'resources/assets/react-app/uiHooks/react-social/profileUnderProfileImage';

import { Link } from 'react-router-dom';

import image from 'Demora/image';

import './Profile.css';

class ShowUserSnapShot extends Component {
	render() {
		const { obj, user, underName, className } = this.props;

		return (
			<div className={className}>
				<div
					className='mt-2 mb-2 p-3 border border-light'
					style={{ height: '250px', overflow: 'hidden' }}
				>
					<div className='row'>
						<div className='col profile-photo-container'>
							<Link to={'/profile/' + obj}>
								<img
									src={!user ? '' : image(user.image, 100)}
									className='profile-photo rounded show-in-modal'
									style={{ padding: '2px', border: 'solid 1px #bbb' }}
								/>
							</Link>
							<div style={{ whiteSpace: 'nowrap' }}>
								<ProfileUnderProfileImage obj={obj} />
							</div>
						</div>
						<div className='col profile-opts'>
							<div className='d-flex'>
								<Link to={'/profile/' + obj}>
									<h4 style={{ maxWidth: '300px', whiteSpace: '' }}>
										{user.first_name + ' ' + user.last_name}
									</h4>
								</Link>
								<ProfileNextToName obj={obj} />
							</div>
							{!!underName && <div>{underName}</div>}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default ShowUserSnapShot;
